module.exports = __webpack_public_path__ + "static/screens-d3adb00ded44cfd87835b6352a7b757a.png";